// ==================== API CLIENT ====================
// src/api/client.ts
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001";
const defaultOptions = { credentials: "include" as const };

export const api = {
  async getDashboard() {
    const res = await fetch(`${API_BASE}/api/dashboard`, defaultOptions);
    return res.json();
  },

  async getSessions(page = 1, limit = 20) {
    const res = await fetch(
      `${API_BASE}/api/sessions?page=${page}&limit=${limit}`,
      defaultOptions,
    );
    return res.json();
  },

  async getSession(id: string) {
    const res = await fetch(`${API_BASE}/api/sessions/${id}`, defaultOptions);
    return res.json();
  },

  async getSessionItems(sessionId: string) {
    const res = await fetch(
      `${API_BASE}/api/sessions/${sessionId}/items`,
      defaultOptions,
    );
    return res.json();
  },

  async getSessionGroups(sessionId: string) {
    const res = await fetch(
      `${API_BASE}/api/sessions/${sessionId}/groups`,
      defaultOptions,
    );
    return res.json();
  },

  async getSessionActions(sessionId: string) {
    const res = await fetch(
      `${API_BASE}/api/sessions/${sessionId}/actions`,
      defaultOptions,
    );
    return res.json();
  },

  async getMonthlyReport(month: string) {
    const res = await fetch(
      `${API_BASE}/api/reports/monthly?month=${month}`,
      defaultOptions,
    );
    return res.json();
  },

  async getActionItems(filters = {}) {
    const query = new URLSearchParams(filters);
    const res = await fetch(
      `${API_BASE}/api/actions?${query}`,
      defaultOptions,
    );
    return res.json();
  },

  async updateActionStatus(actionId: string, status: string, note?: string) {
    const res = await fetch(`${API_BASE}/api/actions/${actionId}/status`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status, note }),
      credentials: "include",
    });
    return res.json();
  },

  async getSubscriptionStatus(workspaceId: string) {
    const res = await fetch(
      `${API_BASE}/api/subscription/status?workspaceId=${encodeURIComponent(workspaceId)}`,
      defaultOptions,
    );
    return res.json();
  },

  async createCheckoutSession(
    workspaceId: string,
    options?: { billingCycle?: "monthly" | "yearly" },
  ) {
    const res = await fetch(`${API_BASE}/api/subscription/checkout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ workspaceId, billingCycle: options?.billingCycle }),
      credentials: "include",
    });
    return res.json();
  },
};
